import { Select } from "@material-ui/core"
import React from "react"
import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const JobListingsContainer = styled.div`
  background-color: #fdfdfd;
  overflow-x: hidden;
  margin-top: 146px;
  .breadcrumbs {
    position: absolute;
    top: 0;
    margin-left: -8px;
    color: ${color.copy[500]};
    a {
      color: ${color.copy[800]};
      margin: 0 8px;
      font-weight: 500;
      strong {
        font-weight: 500;
        color: ${color.copy[500]};
      }
    }
  }
  .container-fluid {
    padding: 0;
    .container {
      &.left,
      &.right {
        padding: 150px 0 120px;
        @media (max-width: 1200px) {
          margin: auto !important;
          padding-left: 111px !important;
          padding-right: 111px !important;
        }
        @media (max-width: 575.98px) {
          padding-left: 35px !important;
          padding-right: 35px !important;
        }
      }
      &.left {
        max-width: 470px;
        margin-right: 100px;
        @media (max-width: 1200px) {
          padding: 104px 0 40px;
        }
        @media (max-width: 575.98px) {
          padding: 80px 0 40px;
        }
      }
      &.right {
        padding-top: 20px;
        max-width: 570px;
        margin-left: 30px;
        @media (max-width: 1200px) {
          padding: 24px 0 56px;
        }
      }
    }

    .col-xl {
      padding: 0;

      &.blue {
        &:before {
          content: "";
          position: absolute;
          height: 100%;
          width: 100%;
          background-color: ${color.aliceBlue[50]};
          z-index: 0;
        }
      }
    }
  }
  .eyebrow {
    color: ${color.primary[700]};
    margin-bottom: 30px;
    font-weight: 900;
    position: relative;
    @media (max-width: 575.98px) {
      margin-bottom: 25px;
    }
  }
  .heading {
    position: relative;
    font-size: 48px;
    letter-spacing: -1px;
    font-weight: 900;
    margin-bottom: 58px;
    @media (max-width: 575.98px) {
      font-size: 36px;
      margin-bottom: 48px;
    }
  }
  .subheading {
    color: ${color.primary[700]};
    font-size: 24px;
    font-weight: 900;
    margin-bottom: 24px;
    @media (max-width: 575.98px) {
      font-size: 20px;
    }
  }

  .job-stats {
    font-size: 18px;
    margin-bottom: 44px;
    @media (max-width: 1200px) {
      text-align: center;
      margin-bottom: 40px;
    }
    @media (max-width: 575.98px) {
      margin-bottom: 32px;
    }
  }

  .clear-all {
    background: none;
    -webkit-appearance: none;
    overflow: visible;
    text-transform: none;
    border: none;
    color: ${color.common.linkBlue};
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    padding: 0;
    position: relative;
    svg {
      margin-left: 10px;
      path {
        transition: all 0.5s;
      }
    }
    &:hover {
      text-decoration: underline;
      svg {
        path {
          stroke: ${color.oxfordBlue[900]};
        }
      }
    }
  }

  .no-jobs {
    @media (max-width: 1200px) {
      text-align: center;
    }
    margin-top: 40px;
    p {
      margin-top: 40px;
      color: ${color.oxfordBlue[900]};
      font-size: 24px;
      font-weight: 900;
      @media (max-width: 575.98px) {
        font-size: 20px;
      }
    }
    img {
      max-width: 100%;
    }
  }

  .MuiFormControl-root {
    background: ${color.common.white};
    .MuiInputBase-root {
      border: 1px solid ${color.gray[300]};
      border-radius: 8px;
      font-family: "Avenir", sans-serif;
    }
    .MuiSelect-icon {
      top: calc(50% - 4px);
      right: 16px;
    }
    .MuiSelect-select {
      border-radius: 8px;
      &:focus {
        background: ${color.common.white};
      }
    }
    .MuiSelect-selectMenu,
    .MuiInputBase-input {
      padding: 12px 14px;
    }
    .MuiInputAdornment-positionStart {
      margin: -2px 3px 0 14px;
    }
    .MuiInput-underline {
      &:before,
      &:after {
        display: none;
      }
    }

    .Mui-focused {
      border: 1px solid ${color.primary[400]};
      box-shadow: 0 0 0 4px ${color.primary[50]};
    }
    p {
      margin-bottom: 0;
    }

    .search {
      path {
        fill: gray;
      }
    }
    & + .MuiFormControl-root {
      margin-top: 24px;
    }
  }

  .department-title {
    margin-bottom: 50px;
    @media (max-width: 1200px) {
      flex-wrap: nowrap;
    }
    @media (max-width: 575.98px) {
      margin-bottom: 32px;
    }
  }
  .department {
    padding: 0px;
    & + .department {
      margin-top: 64px;
      @media (max-width: 1200px) {
        margin-top: 70px;
      }
      @media (max-width: 575.98px) {
        margin-top: 64px;
      }
    }
  }
  .job-row {
    @media (max-width: 1200px) {
      flex-wrap: nowrap;
    }
    @media (max-width: 575.98px) {
      flex-wrap: wrap;
    }
  }
  .job-listing {
    position: relative;
    padding: 0 24px;
    &:after {
      content: "";
      position: absolute;
      height: 1px;
      width: 100%;
      z-index: 0;
      background-color: ${color.copy[200]};
      left: 0px;
      bottom: -20px;
      @media (max-width: 1200px) {
        bottom: -28px;
      }
    }
    .job-title {
      color: ${color.oxfordBlue[900]};
      font-size: 20px;
      font-weight: 900;
      line-height: 28px;
      @media (max-width: 1200px) {
        margin-top: 5px;
      }
      @media (max-width: 575.98px) {
        margin-top: 0px;
      }
    }
    .job-dept {
      color: ${color.copy[700]};
    }
    .job-info {
      padding-right: 32px;
      p {
        @media (max-width: 1200px) {
          margin-bottom: 8px;
        }
        @media (max-width: 575.98px) {
          margin-bottom: 6px;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .job-link {
      align-items: center;
      justify-content: flex-end;
      display: flex;
      a {
        @media (max-width: 1200px) {
          display: block;
        }
      }
      button {
        margin-right: 0;
        @media (max-width: 1200px) {
          display: block;
          width: 100%;
        }
      }
      @media (max-width: 575.98px) {
        display: block;
        align-items: unset;
        justify-content: unset;
        margin: 20px 12px 0;
      }

      @media (max-width: 1200px) {
        padding: 0;
      }
      @media (max-width: 575.98px) {
        margin-right: 30px;
      }
    }
    & + .job-listing {
      margin-top: 60px;
    }
    a {
      button {
        @media (max-width: 575.98px) {
          width: 100%;
          margin-top: 8px;
        }
      }
    }
  }
`

const dropdownProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
}

export const StyledSelect = styled(({ className, ...props }) => (
  <Select
    {...props}
    MenuProps={{ classes: { paper: className }, ...dropdownProps }}
  />
))`
  && {
    max-height: 230px;
    border-radius: 8px;
    margin-top: 8px;
    box-shadow: 0 12px 16px -4px rgb(16 24 40 / 10%);
    outline: 1px solid ${color.aliceBlue[50]};
    .MuiButtonBase-root {
      &:hover {
        background-color: ${color.primary[50]};
      }
    }
    .MuiMenuItem-root {
      justify-content: space-between;
      font-family: "Avenir";
      padding-right: 4px;
    }
  }
`
